import React from "react";
import { Navigate } from "react-router-dom";
import { useDormantFeatures } from "../utils/useDormantFeatures";

// The route definition stays mounted. The flag decides whether the original
// screen renders or the URL sends the member to Trips.
export function DormantFeature({ feature, children }) {
  const features = useDormantFeatures();
  if (!features[feature]) {
    return <Navigate to="/trips" replace />;
  }
  return children;
}

// Unknown nested URLs redirect to Trips while the feature is off. While it
// is on, they render nothing, which is how the original router behaved.
export function DormantFallback({ feature }) {
  const features = useDormantFeatures();
  if (!features[feature]) {
    return <Navigate to="/trips" replace />;
  }
  return null;
}
